import { APIError } from "../sdk/api"
import ErrorToast from "../components/miscellaneous/error-toast"
import React from "react"
import { toast } from "react-toastify"

const errorToast = (err: unknown) => {
    const error = err as APIError
    toast.error(<ErrorToast error={error} />, { toastId: error.code || error.msg || "generic_error" })
}

export { errorToast }
